import config from "Config";

const STATE = config.admin_state_acronym.toLowerCase();

const rel_data = require(`./${STATE}/religion`).default;
const anc_data = require(`./${STATE}/ancestry`).default;
const brt_data = require(`./${STATE}/birthplace`).default;
const lng_data = require(`./${STATE}/language`).default;
const lgaNames = require(`./${STATE}/lgas`).default;
const minorGroups = require(`./${STATE}/minorgroups`).default;

const electoralDistrictNames = require(`./${STATE}/electoral_districts`)
  .default;

import lookups from "./lookups";

module.exports = {
  minorGroups,
  communityValues: {
    "2011": {
      Ancestry: anc_data.items,
      Birthplace: brt_data[2011].items,
      Religion: rel_data.items,
      Language: lng_data.items
    },
    "2016": {
      Ancestry: anc_data.items,
      Birthplace: brt_data[2016].items,
      Religion: rel_data.items,
      Language: lng_data.items
    },
    "2021": {
      Ancestry: anc_data.items,
      Birthplace: brt_data[2021].items,
      Religion: rel_data.items,
      Language: lng_data.items
    }
  },
  geoAggregations: {
    "2011": {
      lga: lgaNames["2011"],
      sed: electoralDistrictNames["2011"],
      ste: [config.admin_state_name]
    },
    "2016": {
      lga: lgaNames["2016"],
      sed: electoralDistrictNames["2016"],
      ste: [config.admin_state_name]
    },
    "2021": {
      lga: lgaNames["2021"],
      sed: electoralDistrictNames["2021"],
      ste: [config.admin_state_name]
    }    
  },
  censusYears: [/*"2006",*/ "2011", "2016","2021"],
  lookups
};



// WEBPACK FOOTER //
// ../data/data.js